import styles from "./header.module.css";
import { useIsMobileDevice } from "../../../hooks/mobile/useIsMobileDevice";

import CalendarFilter from "../../organism/Calendar/Header/CalendarFilter";
import CalendarHeaderDate from "./CalendarHeaderDate";
import CalendarHeaderIndicator from "./CalendarHeaderIndicator";
import CalendarHeaderTodayButton from "./CalendarHeaderTodayButton";
import MeetWithButton from "./MeetWithButton";
import CalendarViewButton from "./CalendarViewButton";
import { ToolbarProps } from "react-big-calendar";
import { useBlockSync } from "../../../react-query/useBlockSync";
import SyncIcon from "../../organism/Calendar/Header/SyncIcon";

export default function CalendarHeader(toolbar: ToolbarProps) {
  const isMobileDevice = useIsMobileDevice();

  return (
    <div className={styles["header"]}>
      {isMobileDevice ? (
        <MobileCalendarHeader toolbar={toolbar} />
      ) : (
        <DesktopCalendarHeader toolbar={toolbar} />
      )}
    </div>
  );
}

const MobileCalendarHeader = ({ toolbar }: { toolbar: ToolbarProps }) => {
  return (
    <div className="flex w-full justify-between">
      <div className="flex gap-[15px]">
        <CalendarHeaderDate toolbar={toolbar} />
        <CalendarHeaderTodayButton toolbar={toolbar} />
      </div>
      <CalendarHeaderIndicator toolbar={toolbar} />
    </div>
  );
};

const DesktopCalendarHeader = ({ toolbar }: { toolbar: ToolbarProps }) => {
  const { isFetching } = useBlockSync();

  return (
    <>
      <div className="flex gap-[15px]">
        <div className="flex gap-[8px]">
          <CalendarHeaderDate toolbar={toolbar} />
          <CalendarHeaderIndicator toolbar={toolbar} />
        </div>
        <CalendarHeaderTodayButton toolbar={toolbar} />
      </div>
      <div className="flex gap-[15px] items-center">
        {isFetching && <SyncIcon />}
        <CalendarViewButton toolbar={toolbar} />
        <MeetWithButton />
        <CalendarFilter />
      </div>
    </>
  );
};
